const MKDOCS_CSS = /main\.[A-Fa-f0-9]{8}\.min\.css$/;
const GOOGLE_FONTS = /^https:\/\/fonts\.googleapis\.com/;
const GSTATIC_FONTS = /^https:\/\/fonts\.gstatic\.com/;
const isLink = (node) => node.nodeName === "LINK";
const isSafe = (node) => {
  const href = node?.getAttribute("href") || "";
  const isMkdocsCss = href.match(MKDOCS_CSS);
  const isGoogleFonts = href.match(GOOGLE_FONTS);
  const isGstaticFonts = href.match(GSTATIC_FONTS);
  return isMkdocsCss || isGoogleFonts || isGstaticFonts;
};
const removeUnsafeLinks = (node) => {
  if (isLink(node) && !isSafe(node)) {
    node.remove();
  }
  return node;
};

export { removeUnsafeLinks };
//# sourceMappingURL=links.esm.js.map
